import React from 'react';

export default function CheckModalGPA(props: any) {

    const {
        handleCloseCheckDiffGpaModal,
        exportExcelDiffGpa,
        handleSubmitCheckDiffGpaModal,
        diffGpaNum
    } = props

    return (
        <React.Fragment>
            <div className="" id="modal-approve-check">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">IPS/GPA Scores Not Match!</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container">
                                A discrepancy in IPS/GPA scores was identified for {diffGpaNum} students between the KHS and the Log Generate SP
                            </div>
                            <br />
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm">
                                        <button className="btn btn-primary btn-block full-width m-b"
                                            onClick={() => exportExcelDiffGpa()}
                                        >View Data</button>

                                    </div>
                                    <div className="col-sm">
                                        <button className="btn btn-danger btn-block full-width m-b" onClick={() => handleCloseCheckDiffGpaModal()}>Cancel</button>
                                    </div>
                                    <div className="col-sm">
                                        <button className="btn btn-success btn-block full-width m-b"
                                            onClick={() => handleSubmitCheckDiffGpaModal()}
                                        >Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}